import styled, { css } from 'styled-components'
import { media } from '~/components/GlobalStyle'

export const baseStyle = css`
  background-color: #fff;
  color: ${(props) => props.theme.body.textColor};
  padding: 8px;
  border-radius: ${(props) => props.theme.border.radius || '6px'};
  border: 1px solid ${(props) => props.theme.border.color || '#bdbdbd'};
  outline: 0;

  &::-webkit-calendar-picker-indicator,
  &::-moz-calendar-picker-indicator {
    position: absolute;
    left: 5%;
  }

  &:hover {
    border-color: ${(props) => props.theme.border.hover || '#757575'};
  }
  &:focus {
    border-color: ${(props) => props.theme.border.focus || '#424242'};
  }
`

const errorStyle = css`
  border-color: ${(props) => props.theme.border.error || '#d32f2f'};
`

const blockStyle = css`
  display: block;
  width: 100%;
`

const layouts = {
  vertical: css`
    fieldset {
      display: grid;
      grid-template-columns: 1fr;
      place-items: start stretch;

      input:not([type='checkbox']),
      select,
      textarea {
        display: block;
        width: 100%;
      }

      ${media.medium} {
        grid-template-columns: minmax(150px, 200px) 1fr;

        label {
          padding-top: 4px;
        }
      }
    }
  `,
  horizontal: css`
    fieldset {
      label {
        display: block;
        margin-bottom: 4px;
      }
      input,
      select,
      textarea {
        display: block;
        width: 100%;
      }
    }
  `,
}

type IBaseProps = {
  block?: string
  $error?: boolean
}

type ITextareaProps = {
  minheight?: string
}

type IForm = {
  layout?: 'vertical' | 'horizontal'
}

export const Form = styled.form<IForm>`
  margin: 12px 0;
  ${(props) => (props.layout ? layouts[props.layout] : '')};
`

export const Input = styled.input<IBaseProps>`
  ${baseStyle};
  ${(props) => (props.block ? blockStyle : '')}
  ${(props) => (props.$error ? errorStyle : '')}
`

export const Select = styled.select<IBaseProps>`
  ${baseStyle};
  ${(props) => (props.block ? blockStyle : '')}
  ${(props) => (props.$error ? errorStyle : '')}
`

export const Textarea = styled.textarea<IBaseProps & ITextareaProps>`
  resize: none;
  font-family: inherit;
  font-size: inherit;
  ${baseStyle};
  ${(props) =>
    props.minheight
      ? css`
          min-height: ${props.minheight};
        `
      : css`
          min-height: 200px;
        `}
  ${(props) => (props.block ? blockStyle : '')}
  ${(props) => (props.$error ? errorStyle : '')}
`

export const Label = styled.label`
  font-size: 0.9em;
  font-weight: 600;
  line-height: 1.3;
  color: ${(props) => props.theme.body.textMuted};
`

export const FormFields = styled.fieldset`
  display: block;
  border: 0;
  margin: 0 0 16px;
  padding: 0;
`

export const ErrorMsg = styled.span`
  display: block;
  padding: 2px 0;
  color: ${(props) => props.theme.border.error || '#d32f2f'};
  font-size: 0.85em;
  text-align: left;
  font-style: italic;
`
export const CheckBox = styled.div`
  display:flex;
  align-items: center;
  gap: 2px;

  label {
    padding-top: 0 !important;
  }
`